<template>
    <section class="list-transform">
        <slot></slot>
    </section>
</template>
<style lang="scss">

.list-transform {
   .dx-datagrid {
    
    .dx-page-sizes::after{
        position:relative ;
        opacity: 0.6;
        font-size: 12px;
        content: 'Số lượng bản ghi mỗi trang' ;
        top: 0;
        right: -9px;
        color: #747571;
        line-height: 18px;
      }
    .dx-header-row {
      td {
        text-transform: uppercase;
        text-align: center !important;
        color: black;
        background-color: #F2F3F7;
        font-weight: 500;
      }
    }
    .dx-select-checkbox {
      display: inline-block;
    }
  }
  
}
.dx-datagrid-text-content {
  white-space: normal !important;
}
</style>
<script>
    export default {
        name:"SectionTransformTable"
    }
</script>